export const getOptions = (data) => {
  return data.map((item) => ({ label: `${item.first_name} ${item.last_name}`, value: item.id }));
};
